{
  "ar": {
    "tamin": "التأمين الاجتماعي",
    "salamat": "التأمين الصحي (سلامت)",
    "armed": "تأمين القوات المسلحة",
    "azad": "دفع ذاتي",
    "dana": "تأمين دانا",
    "asia": "تأمين آسيا",
    "alborz": "تأمين البرز",
    "parsian": "تأمين بارسيان",
    "moalem": "تأمين المعلم",
    "kowsar": "تأمين كوثر",
    "ma": "تأمين ما",
    "sina": "تأمين سينا",
    "razi": "تأمين رازي"
  },
  "fr": {
    "tamin": "Sécurité sociale (Tamin)",
    "salamat": "Salamat (assurance santé)",
    "armed": "Forces armées",
    "azad": "Sans assurance",
    "dana": "Assurance Dana",
    "asia": "Assurance Asia",
    "alborz": "Assurance Alborz",
    "parsian": "Assurance Parsian",
    "moalem": "Assurance Moallem",
    "kowsar": "Assurance Kowsar",
    "ma": "Assurance Ma",
    "sina": "Assurance Sina",
    "razi": "Assurance Razi"
  },
  "de": {
    "tamin": "Tamin (Sozialversicherung)",
    "salamat": "Salamat (Krankenversicherung)",
    "armed": "Streitkräfte",
    "azad": "Selbstzahler",
    "dana": "Dana-Versicherung",
    "asia": "Asia-Versicherung",
    "alborz": "Alborz-Versicherung",
    "parsian": "Parsian-Versicherung",
    "moalem": "Moallem-Versicherung",
    "kowsar": "Kowsar-Versicherung",
    "ma": "Ma-Versicherung",
    "sina": "Sina-Versicherung",
    "razi": "Razi-Versicherung"
  }
}
